<template>
    <v-dialog scrollable v-model="modal" :fullscreen="isMobileAndTablet" max-width="700px">
        <v-card v-if="tagType">
            <v-card-title class="primary white--text" :class="{
                headline: !isMobilePort,
                'caption mobile-title': isMobilePort
            }">
                <v-row dense align="center">
                    <v-col cols="auto">
                        <tag-label :tag="typeInfo.tag" />
                    </v-col>
                    <v-col>
                        {{ typeInfo.title }}
                    </v-col>
                    <v-col cols="auto">
                        <v-icon small class="accent2--text" @click="modal = false">
                            close
                        </v-icon>
                    </v-col>
                </v-row>
            </v-card-title>

            <v-card-text class="pa-0">
                <v-container v-if="loading" class="text-center py-12">
                    <v-progress-circular class="py-6" indeterminate color="primary" />
                </v-container>

                <component v-else :is="currentComponent" :data="data" />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import Mobile from '../../../inc/mixins/mobile';
import ESContent from './EsContent';
import ErrataContent from './ErrataContent';
import SRCCContent from './SrccContent';
import TagLabel from './TagLabel.vue';
import { EventNames } from '../../../../classes/EventNames';
import { TagInsightApi } from '../../../../api/TagInsightApi';

export default {
    mixins: [Mobile],
    components: {
        ESContent,
        ErrataContent,
        SRCCContent,
        TagLabel
    },
    data() {
        return {
            modal: false,
            tagType: '',
            data: [],
            loading: true
        };
    },
    computed: {
        typeInfo() {
            const map = {
                es: { title: 'ICC-ES Reports', tag: 'es' },
                errata: { title: 'Errata and Updates Reports', tag: 'errata' },
                srcc: { title: 'ICC-SRCC Reports', tag: 'srcc' }
            };
            return map[this.tagType] || {};
        },
        currentComponent() {
            const map = {
                es: 'ESContent',
                errata: 'ErrataContent',
                srcc: 'SRCCContent'
            };
            return map[this.tagType] || null;
        }
    },
    methods: {
        async loadModal(insight) {
            this.data = [];
            this.loading = true;
            this.modal = true;
            this.tagType = insight.type;
            try {
                const request = {
                    contentId: insight.contentId,
                    chapterId: insight.contentId,
                    reportType: insight.type
                }
                const response = await TagInsightApi.getReportTagInfo(request);
                this.data = response.data?.reportTags || [];
             } catch (error) {
                console.error('Error fetching report tags:', error);
            } finally {
                this.loading = false;
            }
        }
    },
    mounted() {
        EventBus.listen(EventNames.INSIGHT_ES_ERRATA_SRCC_DIALOG, this.loadModal);
    },
    beforeDestroy() {
        EventBus.off(EventNames.INSIGHT_ES_ERRATA_SRCC_DIALOG, this.loadModal);
    }
};
</script>
